import {
  login,
  logout,
  refreshToken,
  getUserInfo,
  clientAutoLoginCode,
  registeredClientCode,
  getInfoByAnthor,
  getAccessTokenByCodeValue,
  redoClientCode,
  refreshTokenByRelogin,
  changeUser
} from '@/api/login'
import {
  getInfo,
  refreshUserToken
} from '@/api/center/index.js'
import {
  getCodes
} from '@/api/code'
import {
  getToken,
  setToken,
  setExpiresIn,
  removeToken
} from '@/utils/auth'
import router from '../../router'
import {getQRCode} from "@/api/center/ewm";
const user = {
  state: {
    token: getToken(),
    name: '',
    userId: '',
    userName: '',
    deptName: '',
    deptId: '',
    avatar: '',
    roles: [],
    roleList: [], // 用户角色+部门机构详细信息
    permissions: [],
    phonenumber: '',
    childrenList: [],
    mainAccountInfo: null, // 家长登录用户的信息
    hasChildAccount: false, // 是否有子账号（是否是家长账号 绑定孩子）
    user:JSON.parse(sessionStorage.getItem('user'))?JSON.parse(sessionStorage.getItem('user')):'',//帐号或者手机号
    password:JSON.parse(sessionStorage.getItem('password'))?JSON.parse(sessionStorage.getItem('password')):'', //密或者短信验证码
    logintype: JSON.parse(sessionStorage.getItem('logintype'))?JSON.parse(sessionStorage.getItem('logintype')):'',//帐号登录还是短信登录
    clientId: JSON.parse(sessionStorage.getItem('clientId'))?JSON.parse(sessionStorage.getItem('clientId')):'',
    redirectUris: JSON.parse(sessionStorage.getItem('redirectUris'))?JSON.parse(sessionStorage.getItem('redirectUris')):'',
    allRoles: JSON.parse(sessionStorage.getItem('allRoles'))?JSON.parse(sessionStorage.getItem('allRoles')):[],//保存完整的数据
    allChildrenList: JSON.parse(sessionStorage.getItem('allChildrenList'))? JSON.parse(sessionStorage.getItem('allChildrenList')):[],//保存完整的数据
    lastLoginRecord: sessionStorage.getItem('lastLoginRecord') ? sessionStorage.getItem('lastLoginRecord'):'', // 上一次登录用户的信息, 用于比对当前登录用户是否与上一次一致  user + _ + deptId + _ + roleId
  },

  mutations: {
    SET_LAST_LOGIN_RECORD(state, lastLoginRecord) {
      state.lastLoginRecord = lastLoginRecord
      sessionStorage.setItem('lastLoginRecord', lastLoginRecord)
    },
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    DEPT_NAME: (state, deptName) => {
      state.deptName = deptName
    },
    DEPT_ID: (state, deptId) => {
      state.deptId = deptId
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLE_LIST: (state, roleList) => {
      state.roleList = roleList
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_PHONENUMBER: (state, phonenumber) => {
      state.phonenumber = phonenumber
    },
    SET_CHILDRENLIST: (state, childrenList) => {
      state.childrenList = childrenList
    },


    SET_LOGINTYPE: (state, logintype) => {
      state.logintype = logintype
      sessionStorage.setItem('logintype', JSON.stringify(logintype))
    },
    SET_USER: (state, user) => {
      state.user = user
      sessionStorage.setItem('user', JSON.stringify(user))
    },
    SET_PASSWORD: (state, password) => {
      state.password = password
      sessionStorage.setItem('password', JSON.stringify(password))
    },
    SET_CLIENTID: (state, clientId) => {
      state.clientId = clientId
      sessionStorage.setItem('clientId', JSON.stringify(clientId))
    },
    SET_REDIRECTURIS: (state, redirectUris) => {
      state.redirectUris = redirectUris
      sessionStorage.setItem('redirectUris', JSON.stringify(redirectUris))
    },
    SET_ALLROLES: (state, allRoles) => {
      state.allRoles = allRoles
      sessionStorage.setItem('allRoles', JSON.stringify(allRoles))
    },
    SET_ALLCHILDRENLIST: (state, allChildrenList) => {
      state.allChildrenList = allChildrenList
      sessionStorage.setItem('allChildrenList', JSON.stringify(allChildrenList))
    },
    SET_MAIN_ACCOUNT_INFO: (state, userInfo) => {
      console.log("SET_MAIN_ACCOUNT_INFO",userInfo)
      state.mainAccountInfo = userInfo
      sessionStorage.setItem('mainAccountInfo', JSON.stringify(userInfo))
    },
    SET_CHILD_ACCOUNT: (state, hasChildAccount) => {
      console.log("SET_CHILD_ACCOUNT",hasChildAccount)
      state.hasChildAccount = hasChildAccount;
      sessionStorage.setItem('hasChildAccount', JSON.stringify(hasChildAccount))
    },
  },
  actions: {
    refreshInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          let user = res.data
          commit('SET_NAME', user.nickName)
          commit('SET_USER_ID', user.userId)
          commit('SET_USER_NAME', user.userName)
          commit('SET_AVATAR', user.avatar)
          // commit('DEPT_NAME', user.dept.deptName)
          // commit('DEPT_ID', user.deptId)
          commit('SET_PHONENUMBER', user.phonenumber)

          if (user.patriarchUser && user.patriarchUser.hasOwnProperty('userName')){
            commit('SET_MAIN_ACCOUNT_INFO', user.patriarchUser);
            commit('SET_CHILD_ACCOUNT', !!user.patriarchUser); // 是否有子账号 (家长账号绑定孩子)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取微信公众号扫码绑定用户的二维码
    getWxCode() {
      return new Promise((resolve, reject) => {
        getQRCode().then(res => {
          if (res.data) {
            localStorage.setItem("wxQrCode", res.data.wxQrCode.ticket)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    reLogin({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        refreshTokenByRelogin(userParams).then(res => {
          if (res.code === 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    reLoginUser({
              commit
            }, userParams) {
      return new Promise((resolve, reject) => {
        changeUser(userParams).then(res => {
          if (res.code === 200 && res.data && res.data.accessTokenValue) {
            commit('SET_TOKEN', res.data.accessTokenValue);
            // 清除当前角色信息
            sessionStorage.removeItem('loginRoleName');
            sessionStorage.removeItem('loginRoleId');
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    /**登录三步走 start */
    Login({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        registeredClientCode(userParams).then(res => {
          if (res.code == 200) {

            commit('SET_LOGINTYPE',userParams.type);
            commit('SET_USER',userParams.user);
            commit('SET_PASSWORD',userParams.password);
            commit('SET_CLIENTID',userParams.clientId);
            commit('SET_REDIRECTURIS',userParams.redirectUris);

            let data = res.data
            let code = data.url.split('=')[1]
            //把这个code存起来 下次选角色以后再拿来用
            let params = {
              clientId: userParams.clientId,
              clientSecret: "BvdmQqGIwRXYKTlu",
              authorizationCodeValue: code,
              authorizationGrantType: 'code'
            }
            getAccessTokenByCodeValue(params).then(result => {
              if (result.code == 200) {
                let tokenData = result.data
                commit('SET_TOKEN', tokenData.accessTokenValue)
                resolve()
              } else {
                reject(result)
              }
            })
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    //获取用户信息
    GetInfo({
      commit
    }) {
      console.log('user', user)
      return new Promise((resolve, reject) => {
        getInfoByAnthor({
          accessTokenValue: user.state.token
        }).then(res => {
          console.log('是否请求', res)
          const userRes = res.data
          // const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          if (res.data.roleList && res.data.roleList.length > 0) { // 验证返回的roles是否是一个非空数组
            console.log(JSON.parse(sessionStorage.getItem('allRoles')))
            if (user.state.allRoles.length === 0){
              commit('SET_ALLROLES', res.data.roles)
              console.log('res.data.roles2222', user.state.allRoles)
            }
            commit('SET_ROLES', res.data.roles)
            commit('SET_PERMISSIONS', res.data.permissions)
            commit('SET_ROLE_LIST', res.data.roleList)

            // commit('SET_LAST_LOGIN_RECORD', JSON.parse(sessionStorage.getItem('user')) + '_' + res.data.deptId + '_' + sessionStorage.getItem('loginRoleId'))

          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
            commit('SET_ALLROLES', ['ROLE_DEFAULT'])
          }
          if (!sessionStorage.getItem('loginRoleName') && !sessionStorage.getItem('loginRoleId')) {
            sessionStorage.setItem('loginRoleName', res.data.deptName + '-' + res.data.roles[0].roleName);
            sessionStorage.setItem('loginRoleId', res.data.roles[0].roleId);
            sessionStorage.setItem('loginDeptId', res.data.deptId);
            sessionStorage.setItem('lastLoginRecord', res.data.userName + '_' + res.data.roles[0].deptId + '_' + res.data.roles[0].roleId)
          }

          commit('SET_NAME', userRes.nickName)
          commit('SET_USER_ID', userRes.userId)
          commit('SET_USER_NAME', userRes.userName)
          commit('SET_PHONENUMBER', userRes.phonenumber)
          if (userRes.patriarchUser.hasOwnProperty('userName')){
            commit('SET_MAIN_ACCOUNT_INFO', userRes.patriarchUser);
            commit('SET_CHILD_ACCOUNT', !!userRes.patriarchUser); // 是否有子账号 (家长账号绑定孩子)
          }else {
            commit('SET_MAIN_ACCOUNT_INFO', null);
            commit('SET_CHILD_ACCOUNT', false);
          }

          localStorage.setItem('userName', userRes.nickName)
          // commit('SET_AVATAR', avatar)
          // commit('DEPT_NAME', userRes.dept.deptName)
          commit('DEPT_ID', userRes.deptId)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 刷新token
    RefreshCurrentToken({
                   commit, dispatch
                 }) {
      return new Promise((resolve, reject) => {
        refreshUserToken().then(res => {
          if (res.code === 200 && res.data && res.data.accessToken) {
            commit('SET_TOKEN', res.data.accessToken);
            dispatch('GetInfo');
            resolve()
          }else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**登录三步走end */
    // 退出系统
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          localStorage.removeItem("deptId")
          localStorage.removeItem("userId")
          localStorage.removeItem("companyCheck")
          localStorage.removeItem("productCheck")
          localStorage.removeItem("wxQrCode")
          user.state.allRoles = [];
          sessionStorage.removeItem('allRoles');
          sessionStorage.removeItem('loginRoleName');
          removeToken()
          resolve()
          // location.href = "https://rz.jhsec.com.cn/authorize/logout",
          // setTimeout(() => {
          //   router.push('/login')
          //   // location.href = '/login'
          // })
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**跳转第三方应用 start */
    clientAutoLogin({
      commit
    }, userParams) {
      return new Promise((resolve, reject) => {
        clientAutoLoginCode(userParams).then(res => {
          if (res.code == 200) {
            let data = res.data
            let code = data.url.split('=')[1]
            let params = {
              clientId: userParams.clientId,
              clientSecret: userParams.clientSecret,
              authorizationCodeValue: code,
              authorizationGrantType: 'code'
            }
            getAccessTokenByCodeValue(params).then(result => {
              if (result.code == 200) {
                let tokenData = result.data
                // commit('SET_TOKEN', tokenData.accessTokenValue)
                resolve(tokenData.accessTokenValue); // 返回访问令牌
              } else {
                reject(result)
              }
            })
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 数据字典
    GetCodes({
      commit
    }, code) {
      return new Promise((resolve, reject) => {
        getCodes(code).then(res => {
          commit('SET_CODES', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
